// extracted by mini-css-extract-plugin
export default {"message-open":"errorMessage_message-open__ZchXN","message-close":"errorMessage_message-close__wrHF4","error-text":"errorMessage_error-text__L7i-g"};